import styled from "styled-components";

export const Container = styled.div`
	width: ${(props) => (props.desktop ? "80%" : "100%")};
	display: flex;
	flex-direction: ${(props) => (props.desktop ? "column" : "column")};
	justify-content: center;
	align-items: ${(props) => (props.desktop ? "flex-start" : null)};
	border: 1px solid #e6e6e6;
	border-radius: 8px;
	padding: 16px 16px;
	div,
	span {
		font-family: "Montserrat", sans-serif !important;
	}
	h5 {
		margin-bottom: 0;
		font-weight: 700;
	}
	.line-name {
		font-size: 14px;
		font-family: "Montserrat", sans-serif !important;
		font-weight: 500;
	}
	.attention-details-message {
		color: #595959;
		width: 100%;
		text-align: left;
		padding-left: 20px;
		font-family: "Montserrat", sans-serif !important;
	}
`;
